import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@mui/material';
import Button from 'react-bootstrap/Button';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import classes from './scss/baseModal.module.scss';
import { useWindowSize } from '../../../utils/hooks';
import { maxMobileSize } from '../../../utils/constants';
import colors from '../../../scss/colors';

function BaseModal(props) {
  const { t } = useTranslation();
  const {
    open = false,
    fullscreen,
    closeHandler,
    confirmHandler,
    pending = false,
    error = false,
    title,
    children,
    disableConfirmBtn = false,
    confirmBtnTxt = t('common.general.save'),
    cancelBtnTxt = t('common.general.back'),
    onlyConfirm = false,
    onlyReject = false,
    hideHeader = false,
    hideFooter = false,
    zIndex = 1600,
    disablePortal = false,
    backgroundColor = colors.WHITE,
    container = document.body,
    marginLeftRight = 4,
    minWidth,
    dialogContentStyle,
    paperWidth
  } = props;

  const size = useWindowSize();

  return (
    <Dialog
      container={container}
      disablePortal={disablePortal}
      fullScreen={fullscreen}
      open={!!open}
      onClose={closeHandler}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{
        minHeight: 500,
        zIndex,
        '& .MuiDialog-paper': {
          borderRadius: '20px',
          overflowY: 'visible',
          backgroundColor,
          width: paperWidth
        },
        '& .MuiDialogContent-root': {
          minWidth,
          overflowY: 'clip',
          ...dialogContentStyle
        }
      }}
    >
      {!hideHeader && (
        <>
          <DialogTitle
            id="alert-dialog-title"
            className={classes.dialogTitle}
            sx={{
              ml: 4,
              mr: 4,
              mt: 4,
              p: 0
            }}
          >
            {title}
            <IconButton onClick={closeHandler}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <hr className={classes.divider} />
        </>
      )}
      <DialogContent
        sx={{
          ml: marginLeftRight,
          mr: marginLeftRight,
          p: 1.5,
          maxWidth: size.width >= maxMobileSize ? 560 : 'auto'
        }}
      >
        {children}
      </DialogContent>
      {error && <p className={classes.error}>{t('common.errors.wentwrong')}</p>}
      {!hideFooter && (
        <DialogActions
          sx={{
            ml: 4,
            mr: 4,
            mb: 4,
            mt: 8,
            p: 0,
            pt: 1
          }}
        >
          {!onlyConfirm && (
            <Button onClick={closeHandler} variant="secondary" className={`outline-button ${classes.btnPadding}`}>
              {cancelBtnTxt}
            </Button>
          )}
          {!onlyReject && (
            <Box sx={{ m: 1, position: 'relative' }}>
              <Button
                onClick={confirmHandler}
                variant="primary"
                disabled={pending || disableConfirmBtn}
                className={`button ${classes.btnPadding}`}
              >
                {confirmBtnTxt}
              </Button>
              {pending && (
                <CircularProgress
                  size={24}
                  sx={{
                    color: colors.WHITE,
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    marginTop: '-12px',
                    marginLeft: '-12px'
                  }}
                />
              )}
            </Box>
          )}
        </DialogActions>
      )}
    </Dialog>
  );
}

export default BaseModal;
